import { useState } from 'react';
import { Form, Input, Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import ApiService from "../../core/service/api-service";


const STUDY_TASK_TYPE = {
    MISSING_IMAGE: 1
};

export default function ReportMissingDicomsModal({ studyId, onSaved, onCancel }) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            const response = await ApiService.StudyTask.Create({
                studyId: studyId,
                taskType: STUDY_TASK_TYPE.MISSING_IMAGE,
                description: values.description
            });

            if (response.success) {
                onSaved && onSaved();
            }
        } catch (error) {
            console.error('Validation failed:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form
            form={form}
            layout="vertical"
            style={{ padding: '16px 0' }}
        >
            <Form.Item
                name="description"
                label={t('Description')}
                rules={[
                    {
                        required: true,
                        message: t('Please enter a description')
                    }
                ]}
            >
                <Input.TextArea
                    rows={4}
                    placeholder={t('Please describe the missing images...')}
                />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
                <Space>
                    <Button onClick={onCancel}>
                        {t('Cancel')}
                    </Button>
                    <Button type="primary" onClick={handleSubmit} loading={loading}>
                        {t('Submit')}
                    </Button>
                </Space>
            </Form.Item>
        </Form>
    );
}
